import { SmoothScrollHero } from '../components/LandingVideo';
import { SmoothScrollHeroMobile } from '../components/MobileHeroSection';


const ScrollSmoothSection = () => {
    return (
        <div>
            <div className="hidden lg:block"> {/* visible uniquement sur grand écran (≥1024px) */}
                <SmoothScrollHero />
            </div>
            {/* <div className="block md:block lg:hidden"> 
                <SmoothScrollHeroMobile />
            </div> */}
        </div>
    );
};

export default ScrollSmoothSection;